import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import style from "./style.css";

export default class Input extends Component {
  handleKeyPress(event) {
    if (event.key === "Enter") {
      const onSubmit = this.props.onSubmit;
      onSubmit();
    }
  }
  render() {
    const finalRootClass = classnames(style.root, this.props.rootClassname);
    return (
      <input
        className={finalRootClass}
        type={this.props.type}
        onChange={this.props.onChange}
        defaultValue={this.props.defaultValue}
        onKeyPress={this.handleKeyPress.bind(this)}
        value={this.props.value}
        disabled={(this.props.disabled === true)}
        placeholder={this.props.placeholder}
      />
    );
  }
}

Input.propTypes = {
  onChange: PropTypes.func,
  type: PropTypes.string.isRequired,
  rootClassname: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

Input.defaultProps = {
  onChange: function() {},
  disabled: false,
  placeholder: '',
};



// WEBPACK FOOTER //
// ./src/components/Input/index.js